import { Navigate, Outlet } from 'react-router-dom'

function PrivateRoute({ children, ...rest }) {
	const user = JSON.parse(localStorage.getItem('user') || '{}')
	const isAdmin = user?.isAdmin
	//console.log("PrivateRoute")
	return localStorage.getItem('token') && isAdmin === true ? (
		<Navigate to="/dashboard" />
	) : (
		<Outlet />
	)
}

export default PrivateRoute
